<template>
  <CBox m="4vw" @click="openProject">
    <CBox
      :rounded="rounded"
      :boxShadow="boxShadow"
      :h="h"
      :w="w"
      :mx="mx"
      class="project select"
    >
      <CImage
        class="projectImage"
        :rounded="rounded"
        :w="imageW"
        :h="imageH"
        :src="imageSrc"
      />
      <CHeading class="projectHeading" fontSize="1.2vw" p="1vw">
        {{ header }}
      </CHeading>
      <CText class="projectText" fontSize="1vw" mx="1vw">
        {{ subHeader }}
      </CText>
    </CBox>
  </CBox>
</template>

<script>
import { CBox, CText, CImage, CHeading } from "@chakra-ui/vue";
import defaultProject from "../assets/img/defaultProject.jpeg";

export default {
  name: "ProjectCard",
  components: {
    CBox,
    CText,
    CImage,
    CHeading,
  },
  methods: {
    openProject() {
      if (this.projectLink === null) {
        return;
      }
      window.open(this.projectLink, "_blank");
    },
  },
  data() {
    return {
      rounded: {
        type: String,
      },
      h: {
        type: String,
      },
      w: {
        type: String,
      },
      header: {
        type: String,
      },
      subHeader: {
        type: String,
      },
      p: {
        type: String,
      },
      mx: {
        type: String,
      },
      imageW: {
        type: String,
      },
      imageH: {
        type: String,
      },
    };
  },
  computed: {
    getDefaultProjectPhoto() {
      return defaultProject;
    },
  },
  created() {
    this.rounded = this.borderRadius;
    this.header = this.heading;
    this.subHeader = this.subHeading;
    this.h = this.height;
    this.w = this.width;
    this.p = this.padding;
    this.mx = this.marginX;
    this.imageW = this.imageWidth;
    this.imageH = this.imageHeight;
  },
  props: {
    borderRadius: {
      type: String,
      default: "2vw",
    },
    heading: {
      type: String,
      default: null,
    },
    subHeading: {
      type: String,
      default: null,
    },
    height: {
      type: String,
      default: "12vw",
    },
    width: {
      type: String,
      default: "8vw",
    },
    padding: {
      type: String,
      default: "3vw",
    },
    marginX: {
      type: String,
      default: "auto",
    },
    boxShadow: {
      type: String,
      default: "1vw 1vw 2vw 0vw #CCDDDD",
    },
    imageSrc: {
      type: String,
      default: defaultProject,
    },
    imageWidth: {
      type: String,
      default: "8vw",
    },
    imageHeight: {
      type: String,
      default: "8vw",
    },
    projectLink: {
      type: String,
      default: null,
    },
  },
};
</script>

<style>
@media screen and (max-width: 480px) {
  .project {
    width: 30vw;
    height: 48vw;
  }
  .projectImage {
    width: 30vw;
    height: 30vw;
  }
  .projectHeading {
    font-size: 2.5vw;
    padding: 1.5vw;
  }
  .projectText {
    font-size: 1.4vw;
  }
}

.select {
  transition: all 0.4s ease-in-out;
}

.select:hover {
  transform: scale(1.1);
  cursor: pointer;
}
</style>
